export default "__VITE_ASSET__mgzPso_N__"